// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile-first responsive design improvements */
/* Resolution and scaling fixes */

/* Base responsive utilities */
@media (max-width: 640px) {
  .container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  
  /* Hide complex animations on mobile for better performance */
  .bubble,
  .animate-float,
  .animate-gradient {
    display: none !important;
  }
  
  /* Improve touch targets */
  button, 
  .btn,
  input[type="button"],
  input[type="submit"] {
    min-height: 44px;
    min-width: 44px;
  }
  
  /* Better text scaling */
  h1 { font-size: 1.5rem; }
  h2 { font-size: 1.25rem; }
  h3 { font-size: 1.125rem; }
  
  /* Improve table responsiveness */
  .table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  /* Better spacing for mobile */
  .space-y-4 > * + * {
    margin-top: 0.75rem;
  }
  
  .space-y-6 > * + * {
    margin-top: 1rem;
  }
}

/* Tablet optimizations */
@media (min-width: 641px) and (max-width: 1024px) {
  .container {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  
  /* Reduce animation complexity on tablets */
  .bubble {
    opacity: 0.5;
  }
}

/* High DPI display optimizations */
@media (min-resolution: 192dpi) {
  /* Ensure crisp rendering on high DPI displays */
  img, 
  .icon,
  svg {
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
  }
}

/* Large screen optimizations */
@media (min-width: 1920px) {
  .container {
    max-width: 1600px;
  }
  
  /* Scale up content for very large screens */
  .text-sm { font-size: 1rem; }
  .text-base { font-size: 1.125rem; }
  .text-lg { font-size: 1.25rem; }
}

/* Print optimizations */
@media print {
  .no-print {
    display: none !important;
  }
  
  .print-break {
    page-break-before: always;
  }
  
  * {
    background: white !important;
    color: black !important;
  }
}

/* Accessibility improvements */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
  
  .bubble,
  .animate-float,
  .animate-gradient {
    display: none !important;
  }
}

/* Dark mode optimizations */
@media (prefers-color-scheme: dark) {
  /* Ensure proper contrast in dark mode */
  .text-gray-500 {
    color: #9ca3af !important;
  }
  
  .text-gray-600 {
    color: #d1d5db !important;
  }
}

/* Focus improvements for keyboard navigation */
button:focus,
input:focus,
select:focus,
textarea:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Loading state improvements */
.loading-skeleton {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Custom scrollbar for webkit browsers */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Mobile-specific scrollbar */
@media (max-width: 768px) {
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
}

/* ── Branch footer clearance ── */
/* Give every page bottom space so the sticky branch bar doesn't cover content */
body {
  padding-bottom: 52px; /* height of sticky branch footer */
}

/* ── Section-level mobile fixes ── */
@media (max-width: 640px) {
  /* Packages carousel — stack cards on mobile */
  [id="packages"] .taj-section-header {
    flex-direction: column;
    gap: 0.75rem;
  }
  /* Rooms grid: single column */
  [id="rooms-section"] .grid {
    grid-template-columns: 1fr !important;
  }
  /* Section horizontal padding */
  section, [id="packages"], [id="rooms-section"] {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  /* Taj two-col header → single col */
  .taj-section-header {
    flex-direction: column !important;
    gap: 1rem !important;
  }
  .taj-section-header__right {
    text-align: left !important;
  }
  /* Modals full-width */
  .modal-content, 
  [role="dialog"] {
    width: 100% !important;
    max-width: 100vw !important;
    margin: 0 !important;
    border-radius: 1.25rem 1.25rem 0 0 !important;
  }
  /* Gallery grid single col */
  .gallery-grid {
    grid-template-columns: 1fr !important;
  }
  /* Fix nav mobile overlap */
  header nav {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }
  /* Chat button: keep above sticky footer */
  .chat-fab {
    bottom: 4.5rem !important;
  }
  /* Back-to-top: keep above sticky footer */
  .back-to-top-btn {
    bottom: 4.5rem !important;
  }
}

/* ── Sticky branch footer scrollbar: hide on mobile ── */
/* The footer uses overflowX: auto; hide the scrollbar itself */
@media (max-width: 640px) {
  .branch-footer-strip::-webkit-scrollbar {
    display: none;
  }
  /* ── Stacking FABs on mobile ── */
  /* Branch footer height is ~52px (3.25rem). We stack above it. */
  .branch-footer-strip {
    height: 52px !important;
  }

  .whatsapp-fab {
    bottom: 4.5rem !important; /* Above branch bar */
    right: 1rem !important;
  }

  .back-to-top-btn {
    bottom: 8.5rem !important; /* Above WhatsApp */
    right: 1rem !important;
    width: 38px !important;
    height: 38px !important;
  }

  .chat-fab {
    bottom: 11.5rem !important; /* Above Back-to-top */
    right: 1rem !important;
    left: auto !important;
  }

  /* Hero adjustments for extra small screens */
  h1 {
    line-height: 1.1 !important;
  }
  
  .btn-gold {
    width: 100% !important;
    justify-content: center !important;
    padding: 0.8rem 1rem !important;
  }
}

@media (min-width: 641px) and (max-width: 1024px) {
  :root {
    --visible-cards: 2;
  }
  .whatsapp-fab {
    bottom: 5.5rem !important;
    right: 1.5rem !important;
  }
  .back-to-top-btn {
    bottom: 9.5rem !important;
    right: 1.5rem !important; 
  }
  .chat-fab {
    bottom: 13.5rem !important;
    right: 1.5rem !important;
    left: auto !important;
  }
}

@media (min-width: 1025px) {
  :root {
    --visible-cards: 3;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD,iCAAiC;;AAEjC,8BAA8B;AAC9B;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,6DAA6D;EAC7D;;;IAGE,wBAAwB;EAC1B;;EAEA,0BAA0B;EAC1B;;;;IAIE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,wBAAwB;EACxB,KAAK,iBAAiB,EAAE;EACxB,KAAK,kBAAkB,EAAE;EACzB,KAAK,mBAAmB,EAAE;;EAE1B,iCAAiC;EACjC;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,8BAA8B;EAC9B;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA,2CAA2C;EAC3C;IACE,YAAY;EACd;AACF;;AAEA,mCAAmC;AACnC;EACE,gDAAgD;EAChD;;;IAGE,0CAA0C;IAC1C,4BAA4B;EAC9B;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,iBAAiB;EACnB;;EAEA,4CAA4C;EAC5C,WAAW,eAAe,EAAE;EAC5B,aAAa,mBAAmB,EAAE;EAClC,WAAW,kBAAkB,EAAE;AACjC;;AAEA,wBAAwB;AACxB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;AACF;;AAEA,+BAA+B;AAC/B;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;;EAEA;;;IAGE,wBAAwB;EAC1B;AACF;;AAEA,4BAA4B;AAC5B;EACE,wCAAwC;EACxC;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,+CAA+C;AAC/C;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,yCAAyC;AACzC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;IACV,WAAW;EACb;AACF;;AAEA,kCAAkC;AAClC,gFAAgF;AAChF;EACE,oBAAoB,EAAE,mCAAmC;AAC3D;;AAEA,qCAAqC;AACrC;EACE,8CAA8C;EAC9C;IACE,sBAAsB;IACtB,YAAY;EACd;EACA,8BAA8B;EAC9B;IACE,qCAAqC;EACvC;EACA,+BAA+B;EAC/B;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;EACA,oCAAoC;EACpC;IACE,iCAAiC;IACjC,oBAAoB;EACtB;EACA;IACE,2BAA2B;EAC7B;EACA,sBAAsB;EACtB;;IAEE,sBAAsB;IACtB,2BAA2B;IAC3B,oBAAoB;IACpB,6CAA6C;EAC/C;EACA,4BAA4B;EAC5B;IACE,qCAAqC;EACvC;EACA,2BAA2B;EAC3B;IACE,gCAAgC;IAChC,iCAAiC;EACnC;EACA,0CAA0C;EAC1C;IACE,yBAAyB;EAC3B;EACA,0CAA0C;EAC1C;IACE,yBAAyB;EAC3B;AACF;;AAEA,yDAAyD;AACzD,+DAA+D;AAC/D;EACE;IACE,aAAa;EACf;EACA,kCAAkC;EAClC,gEAAgE;EAChE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB,EAAE,qBAAqB;IAChD,sBAAsB;EACxB;;EAEA;IACE,yBAAyB,EAAE,mBAAmB;IAC9C,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B,EAAE,sBAAsB;IAClD,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA,6CAA6C;EAC7C;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,kCAAkC;IAClC,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,wBAAwB;EAC1B;EACA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Mobile-first responsive design improvements */\n/* Resolution and scaling fixes */\n\n/* Base responsive utilities */\n@media (max-width: 640px) {\n  .container {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  \n  /* Hide complex animations on mobile for better performance */\n  .bubble,\n  .animate-float,\n  .animate-gradient {\n    display: none !important;\n  }\n  \n  /* Improve touch targets */\n  button, \n  .btn,\n  input[type=\"button\"],\n  input[type=\"submit\"] {\n    min-height: 44px;\n    min-width: 44px;\n  }\n  \n  /* Better text scaling */\n  h1 { font-size: 1.5rem; }\n  h2 { font-size: 1.25rem; }\n  h3 { font-size: 1.125rem; }\n  \n  /* Improve table responsiveness */\n  .table-responsive {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  \n  /* Better spacing for mobile */\n  .space-y-4 > * + * {\n    margin-top: 0.75rem;\n  }\n  \n  .space-y-6 > * + * {\n    margin-top: 1rem;\n  }\n}\n\n/* Tablet optimizations */\n@media (min-width: 641px) and (max-width: 1024px) {\n  .container {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  \n  /* Reduce animation complexity on tablets */\n  .bubble {\n    opacity: 0.5;\n  }\n}\n\n/* High DPI display optimizations */\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  /* Ensure crisp rendering on high DPI displays */\n  img, \n  .icon,\n  svg {\n    image-rendering: -webkit-optimize-contrast;\n    image-rendering: crisp-edges;\n  }\n}\n\n/* Large screen optimizations */\n@media (min-width: 1920px) {\n  .container {\n    max-width: 1600px;\n  }\n  \n  /* Scale up content for very large screens */\n  .text-sm { font-size: 1rem; }\n  .text-base { font-size: 1.125rem; }\n  .text-lg { font-size: 1.25rem; }\n}\n\n/* Print optimizations */\n@media print {\n  .no-print {\n    display: none !important;\n  }\n  \n  .print-break {\n    page-break-before: always;\n  }\n  \n  * {\n    background: white !important;\n    color: black !important;\n  }\n}\n\n/* Accessibility improvements */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n  \n  .bubble,\n  .animate-float,\n  .animate-gradient {\n    display: none !important;\n  }\n}\n\n/* Dark mode optimizations */\n@media (prefers-color-scheme: dark) {\n  /* Ensure proper contrast in dark mode */\n  .text-gray-500 {\n    color: #9ca3af !important;\n  }\n  \n  .text-gray-600 {\n    color: #d1d5db !important;\n  }\n}\n\n/* Focus improvements for keyboard navigation */\nbutton:focus,\ninput:focus,\nselect:focus,\ntextarea:focus {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n/* Loading state improvements */\n.loading-skeleton {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: loading 1.5s infinite;\n}\n\n@keyframes loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* Custom scrollbar for webkit browsers */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Mobile-specific scrollbar */\n@media (max-width: 768px) {\n  ::-webkit-scrollbar {\n    width: 4px;\n    height: 4px;\n  }\n}\n\n/* ── Branch footer clearance ── */\n/* Give every page bottom space so the sticky branch bar doesn't cover content */\nbody {\n  padding-bottom: 52px; /* height of sticky branch footer */\n}\n\n/* ── Section-level mobile fixes ── */\n@media (max-width: 640px) {\n  /* Packages carousel — stack cards on mobile */\n  [id=\"packages\"] .taj-section-header {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n  /* Rooms grid: single column */\n  [id=\"rooms-section\"] .grid {\n    grid-template-columns: 1fr !important;\n  }\n  /* Section horizontal padding */\n  section, [id=\"packages\"], [id=\"rooms-section\"] {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n  }\n  /* Taj two-col header → single col */\n  .taj-section-header {\n    flex-direction: column !important;\n    gap: 1rem !important;\n  }\n  .taj-section-header__right {\n    text-align: left !important;\n  }\n  /* Modals full-width */\n  .modal-content, \n  [role=\"dialog\"] {\n    width: 100% !important;\n    max-width: 100vw !important;\n    margin: 0 !important;\n    border-radius: 1.25rem 1.25rem 0 0 !important;\n  }\n  /* Gallery grid single col */\n  .gallery-grid {\n    grid-template-columns: 1fr !important;\n  }\n  /* Fix nav mobile overlap */\n  header nav {\n    padding-left: 0.75rem !important;\n    padding-right: 0.75rem !important;\n  }\n  /* Chat button: keep above sticky footer */\n  .chat-fab {\n    bottom: 4.5rem !important;\n  }\n  /* Back-to-top: keep above sticky footer */\n  .back-to-top-btn {\n    bottom: 4.5rem !important;\n  }\n}\n\n/* ── Sticky branch footer scrollbar: hide on mobile ── */\n/* The footer uses overflowX: auto; hide the scrollbar itself */\n@media (max-width: 640px) {\n  .branch-footer-strip::-webkit-scrollbar {\n    display: none;\n  }\n  /* ── Stacking FABs on mobile ── */\n  /* Branch footer height is ~52px (3.25rem). We stack above it. */\n  .branch-footer-strip {\n    height: 52px !important;\n  }\n\n  .whatsapp-fab {\n    bottom: 4.5rem !important; /* Above branch bar */\n    right: 1rem !important;\n  }\n\n  .back-to-top-btn {\n    bottom: 8.5rem !important; /* Above WhatsApp */\n    right: 1rem !important;\n    width: 38px !important;\n    height: 38px !important;\n  }\n\n  .chat-fab {\n    bottom: 11.5rem !important; /* Above Back-to-top */\n    right: 1rem !important;\n    left: auto !important;\n  }\n\n  /* Hero adjustments for extra small screens */\n  h1 {\n    line-height: 1.1 !important;\n  }\n  \n  .btn-gold {\n    width: 100% !important;\n    justify-content: center !important;\n    padding: 0.8rem 1rem !important;\n  }\n}\n\n@media (min-width: 641px) and (max-width: 1024px) {\n  :root {\n    --visible-cards: 2;\n  }\n  .whatsapp-fab {\n    bottom: 5.5rem !important;\n    right: 1.5rem !important;\n  }\n  .back-to-top-btn {\n    bottom: 9.5rem !important;\n    right: 1.5rem !important; \n  }\n  .chat-fab {\n    bottom: 13.5rem !important;\n    right: 1.5rem !important;\n    left: auto !important;\n  }\n}\n\n@media (min-width: 1025px) {\n  :root {\n    --visible-cards: 3;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
